/**
 * Keep hero / KPI carbon totals aligned with Scope 1–3 bars when sources diverge (DEEP-BUG-026/027).
 */
export function reconcileHeroCarbonTotalKg(rawTotalKg: number, scopeSumKg: number): number {
  const raw = Number.isFinite(rawTotalKg) && rawTotalKg > 0 ? rawTotalKg : 0;
  const scopes = Number.isFinite(scopeSumKg) && scopeSumKg > 0 ? scopeSumKg : 0;
  if (scopes <= 0) return raw;
  if (!raw) return scopes;
  if (raw / scopes > 1.5 || scopes / raw > 1.5) {
    return scopes;
  }
  return raw;
}
